import React, { useState, useEffect } from "react";
import {
  Box,
  Grid,
  TextField,
  Stack,
  Typography,
  CircularProgress,
} from "@mui/material";
import BreadcrumbComp from "../CommonComponents/Breadcrumb/Breadcrumb";
import { Button } from "reactstrap";
import Datatable from "../CommonComponents/Datatable/Datatable";
import { FollowupListData } from "../../helpers/renderData";
import FollowupModal from "./Followupmodal";
import { getEmployees } from "../../services/employeeService";
import { asCustomerList, getCustomers } from "../../services/customerService";
import {
  addFollowup,
  deleteFollwups,
  editFollowup,
  getFollowups,
} from "../../services/Follwupservices";
import { toastAlert } from "../../helpers/toastAlert";
import ConfirmDeleteModal from "../CommonComponents/Confrimationmodal";
import { withRouter } from "react-router-dom/cjs/react-router-dom.min";
import { connect } from "react-redux";
import { hasPermission } from "../../utils/commonutils";

const FollowupList = (props) => {
  const [tableData, setTableData] = useState({});
  const [showModal, setShowModal] = useState(false);
  const [modalMode, setModalMode] = useState("add");
  const [selectedFollowup, setSelectedFollowup] = useState(null);
  const [customerData, setCustomerData] = useState([]);
  const [employeeData, setEmployeeData] = useState([]);
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [isFiltered, setIsFiltered] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [totalRows, setTotalRows] = useState(0);
  const [searchText, setSearchText] = useState("");
  const [loading, setLoading] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [deleteId, setDeleteId] = useState("");

  const getEmployeeList = async () => {
    try {
      const employees = await getEmployees(props, 1, 100000000);
      const list = Array.isArray(employees?.data?.employees)
        ? employees.data.employees
        : [];
      setEmployeeData(list);
      if (!list.length) {
        toastAlert(
          employees?.message || "Could not load employees for assignment",
          "error"
        );
      }
    } catch (error) {
      setEmployeeData([]);
      toastAlert("Could not load employees for assignment", "error");
    }
  };

  const getCustomersList = async () => {
    const customers = await getCustomers(props, 1, 10000000);
    setCustomerData(asCustomerList(customers));
  };

  const loadData = async () => {
    try {
      setLoading(true); 

      const response = await getFollowups(
        props,
        currentPage,
        rowsPerPage,
        searchText,
        fromDate , toDate
      );
      const list = response?.data?.items || [];

      const tableResponse = await FollowupListData(list, {
        onEdit: handleEditFollowup,
        onDelete: openDeleteModal,
      });

      setTableData(tableResponse);
      setTotalRows(response?.data?.total || 0);
    } catch (err) {
      toastAlert("Error loading follow-ups", "error");
    } finally {
      setLoading(false); // <-- hide loader
    }
  };

  const handleAddNew = () => {
    setSelectedFollowup(null);
    setModalMode("add");
    setShowModal(true);
  };

  const handleEditFollowup = (data) => {
    setSelectedFollowup(data);
    setModalMode("edit");
    setShowModal(true);
  };

  const openDeleteModal = (id) => {
    setDeleteId(id);
    setShowDeleteModal(true);
  };

  const confirmDelete = async () => {
    try {
      await deleteFollwups(deleteId, props);
      toastAlert("Follow-up deleted successfully", "success");
      setShowDeleteModal(false);
      setDeleteId("");
      loadData();
    } catch (err) {
      toastAlert("Delete failed", "error");
    }
  };

  const handleSubmit = async (formData) => {
    try {
      let response;
      if (modalMode === "add") {
        response = await addFollowup(props, formData);
      } else {
        response = await editFollowup(props, formData, selectedFollowup._id);
      }
      if (
        response?.data.code === 200 ||
        response?.data?.code === 201 ||
        response?.code === 200 ||
        response?.code === 201
      )
        toastAlert(
          response?.data?.message || response?.message || "Success",
          "success"
        );
      else toastAlert("Failed to create", "error");
      setShowModal(false);
      loadData();
    } catch (error) {
      toastAlert("Something went wrong", "error");
    }
  };

  const handleFilter = () => {
    if (fromDate && toDate) setIsFiltered(true);
    loadData();
  };

  const handleReset = async() => {
    setFromDate("");
   setToDate("");
    setSearchText("");
    setIsFiltered(false);
  };

  useEffect(() => {
    loadData();
    getCustomersList();
    getEmployeeList();
  }, [currentPage, rowsPerPage, searchText , isFiltered]);

  const itemArray = () => [{ name: "All Follow-ups", active: true, link: "" }];

  return (
    <div>
     <Grid
  container
  alignItems="center"
  justifyContent="space-between"
  style={{ marginBottom: 16 }}
>
  {/* Breadcrumb : Left */}
  <Grid item>
    <BreadcrumbComp items={itemArray()} />
  </Grid>

  {/* Add Followup Button : Right */}
  {hasPermission("create_followup") && (
    <Grid item>
      <Button
        className="btn btn-colored"
        onClick={handleAddNew}
      >
        + Add New
      </Button>
    </Grid>
  )}
</Grid>
      {/* Date Filter */}
      <Stack direction="row" spacing={2} alignItems="end" mt={3}>
        <Box className="followuplist">
          <Typography fontSize={14} fontWeight={500}>
            From
          </Typography>
          <TextField
            type="date"
            size="small"
            value={fromDate}
            onChange={(e) => setFromDate(e.target.value)}
            sx={{ width: 230 }}
          />
        </Box>
        <Box className="followuplist">
          <Typography fontSize={14} fontWeight={500}>
            To
          </Typography>
          <TextField
            type="date"
            size="small"
            value={toDate}
            onChange={(e) => setToDate(e.target.value)}
            sx={{ width: 230 }}
          />
        </Box>
        <Button
          onClick={handleFilter}
          style={{
            height: 40,
            backgroundColor: "var(--thm-color)",
            width: 100,
          }}
        >
          Filter
        </Button>
        {isFiltered && (
          <Button
            onClick={handleReset}
            style={{
              height: 40,
              backgroundColor: "var(--thm-color)",
              width: 100,
            }}
          >
            Reset
          </Button>
        )}
      </Stack>

      {/* Datatable */}
      <Grid container className="data-table-main" mt={1}>
        <Grid item lg={12}>
          <div
            className="card-main"
            style={{ width: "100%", padding: 12, position: "relative" }}
          >
            {loading && (
              <div
                style={{
                  position: "absolute",
                  top: "60px",
                  left: "60px",
                  zIndex: 10,
                }}
              >
                <CircularProgress style={{ color: "#5F5BA8" }} size={35} />
              </div>
            )}

            <Datatable
              props={tableData}
              title="All Follow-ups"
              currentPage={currentPage}
              TotalRow={totalRows}
              rowsPerPage={rowsPerPage}
              onPageChange={(page, rows) => {
                setCurrentPage(page);
                setRowsPerPage(rows);
              }}
              onSearchChange={(search) => {
                setSearchText(search);
                setCurrentPage(1);
              }}
            />
          </div>
        </Grid>
      </Grid>

      {/* Add/Edit Modal */}
      {showModal && (
        <FollowupModal
          isOpen={showModal}
          mode={modalMode}
          followupData={selectedFollowup}
          employeeData={employeeData}
          customerData={customerData}
          onClose={() => setShowModal(false)}
          onSubmit={handleSubmit}
          props={props}
        />
      )}

      {/* Delete Modal */}
      <ConfirmDeleteModal
        open={showDeleteModal}
        onClose={() => setShowDeleteModal(false)}
        onConfirm={confirmDelete}
        message="Are you sure you want to delete this follow-up?"
      />
    </div>
  );
};

const mapStateToProps = (state) => ({ authData: state.authReducer });
export default withRouter(connect(mapStateToProps)(FollowupList));
